export default __webpack_public_path__ + "351893658a043dbe71c768ec4a0826e1.jpg";